module.exports = __webpack_public_path__ + "static/media/ai&machineLearningLogo.41f8a55e.svg";